import {debounce} from "./helpers";

class SavingCalc {
    constructor(section) {
        this.section = section;
        this.initElements(section);
        this.init();
        this.initEventListeners();
    }

    initElements(section) {
        this.savingsDisplay = section.querySelector('.savings-calc-savings');
        this.quantityParcel = section.querySelector('.savings-calc-savings-quantityParcel');
        this.quantityPallet = section.querySelector('.savings-calc-quantityPallet');
        this.numParcelInput = section.querySelector('.savings-calc-savings-numParcel');
        this.numPalletInput = section.querySelector('.savings-calc-numPallet');
        this.discountParcel = parseFloat(section.querySelector('.savings-calc').dataset.discountParcel) || 0;
        this.discountPallet = parseFloat(section.querySelector('.savings-calc').dataset.discountPallet) || 0;
        this.parcelErrorMsg = section.querySelector('.parcel-error-msg');
        this.palletErrorMsg = section.querySelector('.pallet-error-msg');
        this.calcutationButton = section.querySelector('.calc__btn');
    }

    init() {
        this.updateAndCalculate();
    }

    initEventListeners() {
        // Event listeners for sliders
        this.numParcelInput.addEventListener('input', () => this.updateFromSlider('parcel'));
        this.numPalletInput.addEventListener('input', () => this.updateFromSlider('pallet'));

        // Event listeners for quantity inputs with validation
        this.quantityParcel.addEventListener('input', debounce(() => this.updateFromInput('parcel')), 300);
        this.quantityPallet.addEventListener('input', debounce(() => this.updateFromInput('pallet')), 300);
    }

    validateAndSyncInput(quantityInput, sliderInput, errorMsg) {
        this.clearError(errorMsg);

        const max = parseInt(quantityInput.getAttribute('max'), 10);
        const min = parseInt(quantityInput.getAttribute('min'), 10);
        let quantity = parseInt(quantityInput.value, 10) || '0';

        if (quantity > max || quantity < min) {
            if (quantity > max) {
                this.showError(errorMsg, `${errorMsg.getAttribute('data-notice-max')} ${max}`);
                quantity = max;
            } else if (quantity < min) {
                this.showError(errorMsg, `${errorMsg.getAttribute('data-notice-min')} ${min}`);
                quantity = min;
            }
            quantityInput.value = quantity;
        }

        sliderInput.value = quantity;
    }

    updateFromSlider(type) {
        switch (type) {
            case 'parcel':
                this.quantityParcel.value = parseInt(this.numParcelInput.value, 10);
                this.clearError(this.parcelErrorMsg);
                break;
            case 'pallet':
                this.quantityPallet.value = parseInt(this.numPalletInput.value, 10);
                this.clearError(this.palletErrorMsg);
                break;
            default:
                console.error('Unknown type:', type);
                break;
        }
        this.updateAndCalculate();
    }

    updateFromInput(type) {
        switch (type) {
            case 'parcel':
                this.validateAndSyncInput(this.quantityParcel, this.numParcelInput, this.parcelErrorMsg);
                break;
            case 'pallet':
                this.validateAndSyncInput(this.quantityPallet, this.numPalletInput, this.palletErrorMsg);
                break;
            default:
                console.error('Unknown type:', type);
                break;
        }
        this.updateAndCalculate();
    }

    showError(element, message) {
        element.textContent = message;
        element.style.display = 'block';
    }

    clearError(element) {
        element.textContent = '';
        element.style.display = 'none';
    }

    updateAndCalculate() {
        const parcelQuantity = parseInt(this.numParcelInput.value, 10) || 0;
        const palletQuantity = parseInt(this.numPalletInput.value, 10) || 0;
        const savings = (((parcelQuantity * this.discountParcel) + (palletQuantity * this.discountPallet)) * 52);
        this.savingsDisplay.textContent = savings ? savings.toLocaleString('sv-SE') : '0';

        this.calcutationButton && this.updateCalculationButtonURL(savings, parcelQuantity, palletQuantity);
    }

    updateCalculationButtonURL(savings, parcelQuantity, palletQuantity) {
        const currentURL = new URL(this.calcutationButton.getAttribute('href'), window.location.origin);

        currentURL.searchParams.set('annual_savings', savings);
        currentURL.searchParams.set('parcel_volume_weekly', parcelQuantity);
        currentURL.searchParams.set('pallet_volume_weekly', palletQuantity);

        this.calcutationButton.setAttribute('href', currentURL.toString());
    }
}

export default SavingCalc;



// WEBPACK FOOTER //
// ./scripts/modules/costSavingsCalc.js